import * as actions from './actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import firebase from 'firebase'
import openpgp from 'openpgp'

function firebaseSignup(email, password) {
  return firebase.auth().createUserWithEmailAndPassword(email, password)
}

async function generateKeyPair(email, keyPassword) {
  const options = {
    userIds: [{ email }],
    numBits: 2048,
    passphrase: keyPassword
  }
  const {
    privateKeyArmored: privKey,
    publicKeyArmored: pubKey
  } = await openpgp.generateKey(options)
  return { privKey, pubKey }
}

function storeKeyPair(userId, { privKey, pubKey }) {
  return firebase
    .database()
    .ref('users/' + userId)
    .set({
      keys: { private: privKey, public: pubKey }
    })
}

export function* signup({ payload: { email, password, keyPassword } }) {
  try {
    yield put(actions.signupStart())
    const user = yield call(firebaseSignup, email, password)
    const { privKey, pubKey } = yield call(generateKeyPair, email, keyPassword)
    yield call(storeKeyPair, user.uid, { privKey, pubKey })
    yield put(actions.signupSuccess({ privKey, pubKey }))
  } catch (err) {
    yield put(actions.signupError(err))
  }
}

export default function*() {
  yield takeEvery(actions.signup, signup)
}



// WEBPACK FOOTER //
// ./src/services/signup/sagas.js